module.exports = __webpack_public_path__ + "static/media/avatar-getech.87fd50cd.jpg";